import React, { useState } from "react";
import { Button } from "primereact/button";

const CaptionMenu = ({
    captions = [],
    activeCaptionIndex,
    onCaptionToggle
}) => {
    const [showCaptionMenu, setShowCaptionMenu] = useState(false);

    const handleCaptionClick = (index) => {
        onCaptionToggle(index);
        setShowCaptionMenu(false);
    }

    if (!captions || captions.length === 0) {
        return null;
    }

    return (
        <>

            {/* Caption Button */}
            {captions && captions.length > 0 && (
                <div style={{position: 'relative'}}>
                    <Button
                        icon="pi pi-comments"
                        size="lg"
                        rounded
                        text
                        onClick={() => setShowCaptionMenu(!showCaptionMenu)}
                        style={{color: activeCaptionIndex !== null ? 'var(--primary-color)' : 'white'}}
                        tooltip="Altyazılar"
                        tooltipOptions={{ position: 'top' }}
                    />
                    {showCaptionMenu && (
                        <div style={{
                            position: 'absolute',
                            bottom: '50px',
                            right: '0',
                            backgroundColor: 'rgba(0, 0, 0, 0.9)',
                            borderRadius: '4px',
                            padding: '8px',
                            minWidth: '150px',
                            zIndex: 1000
                        }}>
                            <div
                                style={{
                                    padding: '8px 12px',
                                    cursor: 'pointer',
                                    color: activeCaptionIndex === null ? 'var(--primary-color)' : 'white'
                                }}
                                onClick={() => handleCaptionClick(null)}
                            >
                                Kapalı
                            </div>
                            {captions.map((caption, index) => (
                                <div
                                    key={caption.id || index}
                                    style={{
                                        padding: '8px 12px',
                                        cursor: 'pointer',
                                        color: activeCaptionIndex === index ? 'var(--primary-color)' : 'white'
                                    }}
                                    onClick={() => handleCaptionClick(index)}
                                >
                                    {caption.videoLabel || caption.title}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            )}
        </>
    );
};

export default CaptionMenu;
